import { apiRequest } from '../../api/client';
import { uploadBinary } from '../../api/binary';

export const MAX_PAYMENT_UPLOAD_BYTES = 5 * 1024 * 1024;

const EXTENSION_TYPES = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
};

function contentTypeFor(file) {
  if (file?.type) return file.type;
  const name = file?.name || '';
  return EXTENSION_TYPES[name.slice(name.lastIndexOf('.') + 1).toLowerCase()] || 'application/octet-stream';
}

export const importPaymentHistoryApi = {
  upload: (file, { fetchImpl } = {}) => uploadBinary('/members/import/payments/uploads', file, {
    contentType: contentTypeFor(file), fetchImpl,
  }),
  preview: (input, { fetchImpl } = {}) => apiRequest('/members/import/payments/preview', {
    method: 'POST', body: input, fetchImpl,
  }),
  commit: (input, { fetchImpl } = {}) => apiRequest('/members/import/payments/commit', {
    method: 'POST', body: input, fetchImpl,
  }),
  getResult: (uploadId, { fetchImpl } = {}) => apiRequest(`/members/import/payments/${encodeURIComponent(uploadId)}/result`, {
    method: 'GET', fetchImpl,
  }),
};
